module.exports = __webpack_public_path__ + "img/modal-bg-student-welcome.2518bc6e.png";